import api from "../../../services/api";

export interface RetailEventByDate {
  id: number;
  title: string;
  description: string;
  source: string;
  channel:string;
  location: string;
  start_at: string;
  end_at: string;
}

export type EventsRetailMonthResponse = RetailEventByDate[];

export async function getRetailEventsMonthService(month: string): Promise<EventsRetailMonthResponse> {
  // month format: "2025-08" (YYYY-MM)
  const res = await api.get<EventsRetailMonthResponse>(`/api/key_points/retail/by-month?month=${month}`);
  return res.data;
}